import Validator from './Validator';

export default function validateUpdateCompanyUserPassword(form) {
  // TODO: add custom password validator!
  return Validator.create(form, {
    oldPassword: {
      validators: {
        notEmpty: {
          message: 'Altes Passwort ist ein Pflichtfeld',
        },
      },
    },
    newPassword: {
      validators: {
        notEmpty: {
          message: 'Neues Passwort ist ein Pflichtfeld',
        },
        stringLength: {
          message: 'Passwort muss mindestens 6 Zeichen enthalten',
          min: 6,
        },
      },
    },
    newPasswordRepeat: {
      validators: {
        notEmpty: {
          message: 'Passwort bestätigen ist ein Pflichtfeld',
        },
        callback: {
          message: 'Passwörter stimmen nicht überein.',
          callback: input =>
            form.querySelector('[name="newPassword"]').value ===
            form.querySelector('[name="newPasswordRepeat"]').value,
        },
      },
    },
  });
}
